import { ThirdPartyAnimationSizesType as LoaderSizesType, ThirdPartyAnimationVariantType as LoaderVariantType, } from '../../../../../designSystem/reloaded/commons/components/thirdPartyAnimation/variants';
import { LoadMoreContainerVariantType } from './variants';
export const getLoadMoreContainerStyles = (FOUNDATIONS, FONT) => {
    return {
        [LoadMoreContainerVariantType.DEFAULT]: {
            container: {
                display: 'flex',
                flex_direction: 'column',
                align_items: 'center',
                gap: FOUNDATIONS.spacing_200,
                padding: `${FOUNDATIONS.spacing_300} ${FOUNDATIONS.spacing_150}`,
            },
            loader: {
                variant: LoaderVariantType.SECONDARY,
                size: LoaderSizesType.SMALL,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map